import { Route, Routes } from 'react-router-dom'
import { TablePermission } from './table'

export const BrowserPermission = () => {
  return (
    <Routes>
      <Route path={"/"} element={<TablePermission />} />
    </Routes>
  )
}